import Route from '@ember/routing/route';
import { useQuery } from 'glimmer-apollo';
import { STREAMER_QUERY } from 'embroil/gql/queries/streamer';
import { service } from '@ember/service';

export default class Streamer extends Route {
  @service head;

  async model({ streamer_slug }) {
    try {
      this.data = useQuery(this, () => [
        STREAMER_QUERY,
        { variables: { slug: streamer_slug } },
      ]);

      await this.data.promise;
      return this.data.data.streamer.items[0];
    } catch (error) {
      console.error('Error loading streamer:', error);
      // Redirect to 404 or return null to show error page
      this.replaceWith('404');
      return null;
    }
  }

  afterModel(model) {
    if (model) {
      this.head.updateMeta({
        title: model.displayName,
        description: model.bio || `Watch ${model.displayName}'s gaming streams`,
        ogTitle: model.displayName,
        ogDescription: model.bio || `Watch ${model.displayName}'s gaming streams`,
        ogImage: model.bannerImage?.url || model.avatar?.url,
        canonical: `https://1vX.gg/streamer/${model.slug}`
      });
    }
  }
}
